import {ReactNode} from 'react';
import {Button, OverlayTrigger, Popover, Tooltip} from 'react-bootstrap';

interface PopoverButtonProps {
    tooltipContent: ReactNode;
    iTagClass: string;
    buttonClass?: string;
}

export function PopoverButton({ tooltipContent, iTagClass, buttonClass }: PopoverButtonProps) {
    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {tooltipContent}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement="top"
            delay={{show: 100, hide: 400}}
            overlay={renderTooltip}
        >
            <Button as={"span"} className={`btn border-0 ${buttonClass ?? "p-1"}`} variant={null}>
                <i className={iTagClass}/>
            </Button>
        </OverlayTrigger>
    );
}
